<div *ngIf="this.pagination !== null" class="pagination" data-testid="pagination">
  <mat-paginator
    #paginator
    class="demo-paginator"
    (page)="handlePageEvent($event)"
    [length]="this.pagination?.count"
    [pageSize]="this.pagination?.limit"
    [showFirstLastButtons]="true"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="(this.pagination?.page)! - 1"
    aria-label="Select page"
  >
  </mat-paginator>
  <button class="activ_btn" data-testid="pagination-page-indicator">
    {{ pagination?.page }}/{{ pagination?.pages }}
  </button>
</div>
